import { type PageName, getPageName, getPageNumber } from './pageUtil';
import { restoreFromSlug } from './urlUtil';

export const parseCategorySlug = (
  slug: string,
): { categoryName: string; categoryId: string } => {
  const lastDashIndex = slug.lastIndexOf('-');
  const categoryName = slug.slice(0, lastDashIndex);
  const categoryId = slug.slice(lastDashIndex + 1) || '';

  return {
    categoryName: restoreFromSlug(categoryName),
    categoryId,
  };
};

export const parseThreadSlug = (
  slug: string,
): { threadTitle: string; threadId: string } => {
  const lastDashIndex = slug.lastIndexOf('-');
  const threadTitle = lastDashIndex > 0 ? slug.slice(0, lastDashIndex) : '';
  const threadId = slug.slice(lastDashIndex + 1) || '';

  return {
    threadTitle: restoreFromSlug(threadTitle),
    threadId,
  };
};

export const getCategoryIdAndPageNumberFromFullUrl = (
  fullURL: string,
  params: Record<string, string | undefined>,
): { categoryId: string; pageNumber: number } => {
  const url = new URL(fullURL);
  const pageName = getPageName(url.pathname);
  const { categoryId } = getCategoryIdentifiers(pageName, params);
  return {
    categoryId,
    pageNumber: getPageNumber(url.search),
  };
};

export const getCategoryIdentifiers = (
  pageName: PageName,
  params: Record<string, string | undefined>,
): { categoryId: string; categoryName: string } => {
  if (pageName === 'CommunityGroupDetails' && params.groupSlug) {
    const { categoryId, categoryName } = parseCategorySlug(params.groupSlug);
    return { categoryId, categoryName };
  }
  return { categoryId: '', categoryName: '' };
};
